import DesignOutputSidebar from './DesignOutputSidebar';
import DesignResultViewer from './DesignResultViewer';

/**
 * Shared output layout for AI tool pages after image generation.
 *
 * @param {{
 *   project: Record<string, unknown>;
 *   resultViewMode: ResultViewMode;
 *   onResultViewModeChange: (mode: ResultViewMode) => void;
 *   onEdit?: () => void;
 *   onDelete?: () => void;
 *   onOpenShop?: () => void;
 *   onNewProject?: () => void;
 *   shopItemCount?: number;
 *   showEdit?: boolean;
 *   onDownloadImage?: (url: string, baseName: string) => void;
 *   onZoomImage?: (payload: { src: string; alt: string }) => void;
 *   downloadError?: string;
 *   enableWideImageStretch?: boolean;
 * }} props
 */
export default function DesignOutputWorkspace({
  project,
  resultViewMode,
  onResultViewModeChange,
  onEdit,
  onDelete,
  onOpenShop,
  onNewProject,
  shopItemCount = 0,
  showEdit = true,
  onDownloadImage,
  onZoomImage,
  downloadError = '',
  enableWideImageStretch = false,
}) {
  return (
    <div className="project-result-content">
      <section className="dashboard-grid new-design-workspace design-dual-layout output-mode">
        <article className="card new-design-setup-card project-result-setup-card">
          <DesignOutputSidebar
            project={project}
            resultViewMode={resultViewMode}
            onResultViewModeChange={onResultViewModeChange}
            onEdit={onEdit}
            onDelete={onDelete}
            onOpenShop={onOpenShop}
            onNewProject={onNewProject}
            shopItemCount={shopItemCount}
            showEdit={showEdit}
          />
        </article>

        <DesignResultViewer
          project={project}
          resultViewMode={resultViewMode}
          onDownloadImage={onDownloadImage}
          onOpenShop={onOpenShop}
          onZoomImage={onZoomImage}
          previewLayout="plain"
          showMobileActions={false}
          showShopOnMobile={false}
          enableWideImageStretch={enableWideImageStretch}
        />
      </section>

      {downloadError ? (
        <p className="dashboard-inline-error project-detail-download-error" role="alert">
          {downloadError}
        </p>
      ) : null}
    </div>
  );
}
